import { create } from 'zustand';
import { getSubscription } from '@/api/billing';
import { IS_BACKEND_CONFIGURED } from '@/api/config';

export interface PlanState {
  plan: 'free' | 'hobby' | 'pro' | 'team';
  status: 'active' | 'canceled' | 'past_due' | 'trialing' | 'none';
  currentPeriodEnd: string | null;
  isLoading: boolean;
  fetchPlan: () => Promise<void>;
}

export const usePlanStore = create<PlanState>((set) => ({
  plan: 'free',
  status: 'none',
  currentPeriodEnd: null,
  isLoading: false,

  fetchPlan: async () => {
    if (!IS_BACKEND_CONFIGURED) return;

    set({ isLoading: true });
    try {
      const info = await getSubscription();
      set({
        plan: info.plan,
        status: info.status,
        currentPeriodEnd: info.currentPeriodEnd,
        isLoading: false,
      });
    } catch {
      // On error, keep defaults (free plan)
      set({ isLoading: false });
    }
  },
}));
